<script lang="ts">
  import { page } from '$app/stores'

  import { getLocalizedLink } from '~/utils/getLocalizedLink'
  import type { LinkLocaleProps } from './link-locale.types'

  let locale = $derived($page.params.locale)

  const { children, href, ...props }: LinkLocaleProps = $props()
</script>

<a href={getLocalizedLink(locale, href || '')} {...props}>
  {@render children()}
</a>
